import { render, staticRenderFns } from "./GalleryFeed.vue?vue&type=template&id=3bd68cc7&"
import script from "./GalleryFeed.vue?vue&type=script&lang=ts&"
export * from "./GalleryFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports